import { render, staticRenderFns } from "./AgreementItems.vue?vue&type=template&id=5ad258e2&"
import script from "./AgreementItems.vue?vue&type=script&lang=js&"
export * from "./AgreementItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports